export default __webpack_public_path__ + "static/media/trophy3.d3720f51.png";